import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

type SetInfo = { id: string; name: string; slug: string; count: number };

export default function SetSelection() {
  const [sets, setSets] = useState<SetInfo[]>([]);
  useEffect(() => {
    (async () => {
      const res = await fetch('/cards/index.json');
      const data = await res.json();
      setSets(data);
    })();
  }, []);

  return (
    <div className="p-6 text-white">
      <h1 className="text-3xl font-bold mb-6">Choose a Set</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {sets.map((s) => (
          <div key={s.slug} className="bg-black/40 rounded-lg p-4">
            <div className="text-xl font-semibold mb-2">{s.name}</div>
            <div className="text-sm opacity-70 mb-4">{s.count} cards</div>
            <Link to={`/binder/${encodeURIComponent(s.name)}`} className="inline-block bg-blue-600 hover:bg-blue-500 text-white px-4 py-2 rounded">
              Open Binder
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}


